import Joi from 'joi';
import PropTypes from 'prop-types';

import Conditional from '../../common/conditional';
import Form from '../../common/form';

import { SelectOption, UTMReadingItem } from '../../../utils/models';
import { OTHER_DESCRIPTION, UTM_READING_ITEM_AFFIX } from '../../../utils/constants';
import { matchPhrases } from '../../../utils/utilities';

import toastService from '../../../services/toastService';

class CustomUTMSummaryReadingItem extends Form {
	state = {
		data: { thickness: '', option: '', otherOption: '' },
		errors: {},
		loading: false,
		progress: 0,
		thicknessMeasurementOptions: [],
	};

	schema = {
		thickness: Joi.number().min(0).required().label('Thickness'),
		option: Joi.string().min(1).required().label('Thickness Readings'),
		otherOption: Joi.string().when('option', {
			is: OTHER_DESCRIPTION,
			then: Joi.string().min(3).required().label('Thickness Reading Description'),
			otherwise: Joi.string().allow('').label('Thickness Reading Description'),
		}),
	};

	static propTypes = {
		options: PropTypes.array,
		onAdd: PropTypes.func,
		readings: PropTypes.array,
	};

	componentDidMount() {
		this.setState({ thicknessMeasurementOptions: this.props.options } as any);
	}

	doSubmit = (): void => {
		const optionLabel = this.getOptionLabel();

		if (this.getReadingMatch(optionLabel)) return toastService.error('Option already added!');
		if (matchPhrases(optionLabel, OTHER_DESCRIPTION)) return toastService.error('Please specify the option!');

		this.props.onAdd({
			label: `${this.state.data.thickness} ${UTM_READING_ITEM_AFFIX} ${this.getOptionLabel()}`,
			thickness: this.state.data.thickness, 
			option: optionLabel,
		});

		this.setState({ data: { thickness: '', option: '', otherOption: '' } });
	};

	getOptionLabel = () => {
		if (this.state.data.option === OTHER_DESCRIPTION) {
			return this.state.data.otherOption;
		}

		return this.state.data.option;
	};

	getReadingMatch = (readingToMatch: string) => {
		return this.props.readings.find((reading: UTMReadingItem) => matchPhrases(readingToMatch, reading.option))
	}

	getThicknessOptions = () => {
		return this.state.thicknessMeasurementOptions.filter((option: SelectOption) => {
			return !this.getReadingMatch(option.id.toString())
		});
	};

	render() {
		return (
			<form onSubmit={this.handleSubmit}>
				<div className="container">
					<div className="row">
						<div className="col">
							{this.renderInput({
								type: 'number',
								name: 'thickness',
								label: 'Thickness',
								placeholder: 'Enter Thickness (mm)',
							})}
						</div>
						<div className="col d-flex align-items-center justify-content-center">
							{UTM_READING_ITEM_AFFIX}
						</div>
						<div className="col">
							{this.renderSelect({
								options: this.getThicknessOptions(),
								name: 'option',
								placeholder: 'Select Thickness Option',
								label: 'Thickness Option',
							})}
						</div>
						<Conditional isVisible={this.state.data.option === OTHER_DESCRIPTION}>
							<div className="col">
								{this.renderInput({
									name: 'otherOption',
									type: 'text',
									placeholder: 'Enter Thickness Option Description',
									label: 'Thickness Option Description',
								})}
							</div>
						</Conditional>
					</div>

					<div className="d-flex justify-content-end">
						{this.renderButton('Add')}
					</div>
				</div>
			</form>
		);
	}
}


export default CustomUTMSummaryReadingItem;
